import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'rovoIsThinking'
	| 'awaitingUserResponse'
	| 'successStatusLabel'
	| 'errorStatusLabel';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		rovoIsThinking: {
			id: 'conversation-assistant-ui-components.conversation-status-label.rovo-is-thinking.ai-non-final',
			defaultMessage: 'Rovo is thinking...',
			description:
				'Status text shown beneath a conversation summary while Rovo is actively processing the conversation and preparing a response.',
		},
		awaitingUserResponse: {
			id: 'ai-mate.conversation-status-label.awaiting-user-response',
			defaultMessage: 'Awaiting user response',
			description:
				'Footer line in a chat conversation list when the task is waiting on the user (e.g. plan confirmation or disambiguation).',
		},
		successStatusLabel: {
			id: 'ai-mate.conversation-status-label.success',
			defaultMessage: 'Done',
			description: 'Footer line when the conversation task completed successfully.',
		},
		errorStatusLabel: {
			id: 'ai-mate.conversation-status-label.error',
			defaultMessage: 'Failed',
			description: 'Footer line when the conversation task failed.',
		},
	});

export default message;
